
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppBarcodeSettingsEditModal from "./BarcodeSettingsEditModal.vue";
import Vue from "vue";
import { SaleLayoutBarcode } from "@/utils/sale-layouts/barcode";

export default Vue.extend({
	data(){
		return {
			selectedLang: "",
			toEditBarcodeIndex: -1,
			toEditBarcode: null as null | SaleLayoutBarcode
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		}
	},
	methods: {
		editBarcode(i:number){
			this.toEditBarcodeIndex = i;
			this.toEditBarcode = this.layout.Barcodes[i];
		},
		removeBarcode(i:number){
			this.layout.Barcodes.splice(i, 1);
		},
		addNewBarcode(){
			this.toEditBarcodeIndex = -1;
			this.toEditBarcode = new SaleLayoutBarcode();
		},
		closeBarcodeEdit(){
			this.toEditBarcodeIndex = -1;
			this.toEditBarcode = null;
		},
		saveBarcode(code:any){
			if (this.toEditBarcodeIndex != -1) {
				// Fixes issue with reactivity
				Vue.set(this.layout.Barcodes, this.toEditBarcodeIndex, new SaleLayoutBarcode(code));
				//this.layout.Barcodes[this.toEditBarcodeIndex] = new SaleLayoutBarcode(code);
			}else{
				this.layout.Barcodes.push(new SaleLayoutBarcode(code));
			}
		}
	},
	components: {
		AppCustomLangSelect,
		AppBarcodeSettingsEditModal
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
